var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _vm.label
      ? _c("label", [
          _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
          _vm.required
            ? _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      staticClass: "form-control",
      attrs: { type: "text", placeholder: _vm.placeholder },
      domProps: { value: _vm.localValue },
      on: { input: _vm.onInput, blur: _vm.onBlur },
    }),
    _vm._v(" "),
    _vm.hint
      ? _c("small", { staticClass: "form-text text-muted" }, [
          _vm._v("\n    " + _vm._s(_vm.hint) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.error
      ? _c("small", { staticClass: "form-text text-danger" }, [
          _vm._v("\n    " + _vm._s(_vm.error) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }